<template>
  <div
    id="notification_board"
    ref="notification_board"
    class="notification_board"
    @mousedown="handleMouseOverNotificationBoard()"
    @mouseleave="handleMouseLeaveNotificationBoard()"
  >
    <div class="modal_qualifier_container">
      <div
        :class="{
          has_notifications: true, hide: !hasNotifications()}"
      >
        <div class="top_qualifier_modal">
          <a class="view_all_notes" :href="routeMyProfile()">View all</a>
          <div class="daily_title notification_text">Notifications</div>
        </div>
        <div class="top_qualifier_modal cakes_earning" @click="showSmashCake()">
          <div class="daily_title" style="text-align: center; padding-top: 0">
            <i class="sp-ic-sm-cake_remain_item" style="vertical-align: middle" />
            <span style="color: #ffffff; font-size: 14px;">You have <span id="notification_cakes_earning" style="color: #ffffff;">{{ numberRewards }}</span>
              Unclaimed Mega Cakes! Click To Win
            </span>
          </div>
        </div>
        <div v-if="allNotifications.length > 0" id="container_board" class="content_container" @scroll.passive="scrollLoad()">
          <notification-item v-for="(notification, index) in allNotifications" :key="index" :notification="notification" />
        </div>
        <!-- <div v-if="allNotifications.length === 0" class="body_qualifier_modal content_small remover_radius" style="border-bottom: 0">
          <div class="background_empty" />
          <i class="sp-ic-md-empty_notification img_empty" />
          <div class="q_modal_message q_message_no_notification">
            <span class="no_notification_message">You have no new notifications</span>
          </div>
        </div> -->
      </div>
      <div :class="{no_notification: true, hide: hasNotifications()}">
        <div class="top_qualifier_modal">
          <div class="daily_title notification_text" style="font-weight: bold;font-size: 16px;">Notifications</div>
        </div>
        <div class="body_qualifier_modal content_small remover_radius" style="border-bottom: 0">
          <div class="background_empty" />
          <i class="sp-ic-md-empty_notification img_empty" />
          <div class="q_modal_message q_message_no_notification">
            <span class="no_notification_message">You have no new notifications</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { component } from '../../mixins/component';
import { mapGetters } from 'vuex';
import { EventBus, SHOW_MODAL_LOGIN, SHOW_MODAL_SMASH_CAKE, LOAD_MORE_NOTIFICATION } from '../../event-bus';
import jQuery from 'jquery';

export default {
  mixins: [component],
  computed: {
    ...mapGetters('notifications', ['isShowingNotificationBoard', 'allNotifications']),
    ...mapGetters('rewards', ['numberRewards']),
  },
  watch: {
    isShowingNotificationBoard: function(newVal, oldVal) {
      if (newVal) {
        if (!oldVal) {
          jQuery(this.$refs.notification_board).slideDown('fast');
        }
      } else {
        if (oldVal) {
          jQuery(this.$refs.notification_board).slideUp('fast');
        }
      }
    },
  },
  created() {
  },
  methods: {
    hasNotifications() {
      return this.numberRewards > 0 || this.allNotifications.length > 0;
    },
    showSmashCake() {
      if (!this.isAuth) {
        EventBus.$emit(SHOW_MODAL_LOGIN);
      } else if (this.numberRewards > 0) {
        EventBus.$emit(SHOW_MODAL_SMASH_CAKE);
      }
    },
    scrollLoad() {
      var scrollTop = document.getElementById('container_board').scrollTop;
      var offsetHeight = document.getElementById('container_board').offsetHeight;
      var scrollHeight = document.getElementById('container_board').scrollHeight;
      if (scrollTop + offsetHeight >= scrollHeight) {
        EventBus.$emit(LOAD_MORE_NOTIFICATION, {});
      }
    },
    handleMouseOverNotificationBoard() {
      this.$store.dispatch('notifications/hoverNotificationBoard', true);
      this.$store.dispatch('notifications/toggleNotificationBoard', true);
    },
    handleMouseLeaveNotificationBoard() {
      this.$store.dispatch('notifications/hoverNotificationBoard', false);
    },
  },
};
</script>
